<template>
    <div class="saving-indicator"
         v-show="show">
        {{ $i18n.gt('LABEL_SAVING_INDICATOR') }}
    </div>
</template>

<script>

import Vue from 'vue'

export default Vue.extend({
    name: "SavingIndicator",
    data() {
        return {
            show: false
        }
    },
    watch: {
        '$store.state.saving': {
            // if saving flag is turned on, show indicator immediately (after any debounce interval);
            // if it's turned off, wait a second to hide the indicator so it doesn't flash too abruptly
            handler: function (newVal, oldVal) {
                setTimeout(() => {
                    this.show = newVal
                }, newVal ? 0 : 1000)
            }
        }
    }
})
</script>

<style lang="scss">
@import '../../sass/variables_mixins';

.saving-indicator {
    @include transition(opacity .3s);
    position: fixed;
    left: 0;
    bottom: 0;
    padding: 10px 20px;
    background-color: cornsilk;
    border-top-right-radius: 10px;
}

</style>
